<template lang="">
  <div class="cardContent">
    <vue-seamless-scroll
      :data="list"
      class="tableBody"
      :class-option="classOption"
    >
      <ul>
        <li
          class="content"
          v-for="(item, index) in list"
          :key="index"
          @click="showDt(item)"
        >
          <div class="flex mainDiv">
            <div class="leftDiv">
              <img :src="$config.imgIp + item.logo" />
            </div>
            <div class="rightDiv flex">
              <div class="rightTop">{{ item.name }}</div>
              <div class="rightBot">
                <p class="address">企业地址：{{ item.address }}</p>
                <p>联系人：{{ item.linkman }}</p>
                <p>联系方式：{{ item.linkmanPhone }}</p>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </vue-seamless-scroll>
  </div>
</template>

<script>
import { findOrgCompanyByIsSubjectGetOrgCompany } from "@/api/base";
// import { mapGetters } from "vuex";
export default {
  components: {},
  computed: {
    classOption() {
      return {
        step: 0.5, // 数值越大速度滚动越快
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true // 开启数据实时监控刷新dom
      };
    }
  },
  props: {
    //是否滚动, 默认滚动
    isScrolled: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      list: []
    };
  },
  mounted() {
    this.getCompanyList();
  },
  methods: {
    getCompanyList() {
      findOrgCompanyByIsSubjectGetOrgCompany().then(res => {
        if (res) {
          this.list = res.data;
        }
      });
    },
    showDt(item) {
      this.$store.dispatch("drawer/setGraphic", item);
      this.$store.dispatch("drawer/setRightComponent", "ssztDrawer");
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'
.cardContent
  height 100%
.tableTitle
  background rgba(0, 66, 82, 0.6)
  color #fff
  padding 10px 5px
  font-size 14px
.tableBody
  height calc(100% - 16px)
  width calc(100% - 20px)
  margin 16px 10px 0
  overflow hidden
  font-size 14px
.scroll-content
  position relative
  transition top 0.1s
.content
  padding 10px 5px
  background rgba(10, 37, 80, 0.7)
  box-shadow 0px 0px 15px #0B4378 inset
  border 1px #0B4378 solid
  color #fff
  margin-bottom 10px
  cursor pointer
  &:hover
    background rgba(17, 117, 204, 0.7)
.content:last-child
  margin-bottom 0px
.line
  height 1px
  background #66ccff
.leftDiv
  width 0.55rem
  height 100%
  margin-right .1rem
  >img
    width 100%
    max-height 90px
.rightDiv
  width calc(100% - 0.65rem)
  // flex 1
  height 100%
  flex-wrap wrap
.rightTop
  font-size 16px
  font-weight bold
.rightMid
  width 100%
.mainDiv
  width calc(100% - 12px)
  padding 0 6px
  // height 0.55rem
.rightBot
  width 100%
  margin-top 10px
  line-height 1.5
  .address
    width 100%
    white-space nowrap
    overflow hidden
    text-overflow ellipsis

@media (max-width 1280px)
  .tableBody
    font-size 0.08rem
</style>
